import React from 'react';
import { observer, inject } from 'mobx-react';
import { Route, Redirect } from 'react-router-dom';

export default inject('userStore')(
  observer(({ userStore, ...rest }) => {
    if (userStore.self) return <Route {...rest} />;
    return <Redirect to="/login" />;
  })
);



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute.js